"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalColumns = exports.InternalColumns = exports.DefaultColumnName = void 0;
var DefaultColumnName;
(function (DefaultColumnName) {
    DefaultColumnName["CmhcDefaultAccountID"] = "CmhcDefaultAccountID";
    DefaultColumnName["ApprovedLenderCode"] = "ApprovedLenderCode";
    DefaultColumnName["ApprovedLenderName"] = "ApprovedLenderName";
    DefaultColumnName["ApprovedLenderReferenceNumber"] = "ApprovedLenderReferenceNumber";
    DefaultColumnName["CmhcLoanAccountNumber"] = "CmhcLoanAccountNumber";
    DefaultColumnName["DefaultStatus"] = "DefaultStatus";
    DefaultColumnName["LenderContactEmail"] = "LenderContactEmail";
    DefaultColumnName["ProvinceCode"] = "ProvinceCode";
    DefaultColumnName["RequestReceivedTimestamp"] = "RequestReceivedTimestamp";
    DefaultColumnName["RequestCreatedUserID"] = "RequestCreatedUserID";
    DefaultColumnName["LastRecordUpdatedTimestamp"] = "LastRecordUpdatedTimestamp";
    DefaultColumnName["CmhcOwnerFirstName"] = "CmhcOwnerFirstName";
    DefaultColumnName["CmhcOwnerLastName"] = "CmhcOwnerLastName";
    DefaultColumnName["CmhcOwnerID"] = "CmhcOwnerID";
    DefaultColumnName["ValidLoan"] = "ValidLoan";
})(DefaultColumnName = exports.DefaultColumnName || (exports.DefaultColumnName = {}));
exports.InternalColumns = [
    DefaultColumnName.CmhcDefaultAccountID,
    DefaultColumnName.ApprovedLenderCode,
    DefaultColumnName.ApprovedLenderName,
    DefaultColumnName.ApprovedLenderReferenceNumber,
    DefaultColumnName.CmhcLoanAccountNumber,
    DefaultColumnName.CmhcOwnerFirstName,
    DefaultColumnName.CmhcOwnerID,
    DefaultColumnName.CmhcOwnerLastName,
    DefaultColumnName.DefaultStatus,
    DefaultColumnName.LastRecordUpdatedTimestamp,
    DefaultColumnName.ProvinceCode,
    DefaultColumnName.RequestCreatedUserID,
    DefaultColumnName.RequestReceivedTimestamp,
    DefaultColumnName.ValidLoan,
];
exports.ExternalColumns = [
    DefaultColumnName.CmhcDefaultAccountID,
    DefaultColumnName.ApprovedLenderCode,
    DefaultColumnName.ApprovedLenderName,
    DefaultColumnName.ApprovedLenderReferenceNumber,
    DefaultColumnName.CmhcLoanAccountNumber,
    DefaultColumnName.DefaultStatus,
    DefaultColumnName.LastRecordUpdatedTimestamp,
    DefaultColumnName.LenderContactEmail,
    DefaultColumnName.RequestCreatedUserID,
    DefaultColumnName.RequestReceivedTimestamp,
    DefaultColumnName.ValidLoan,
];
